import Http from '@/core/http/http.service';

class RequestMeetingFormService {
    submitForm(request: RequestMeetingFormBlockWebRequest): Promise<{redirectUrl: string}> {
        return Http.post<{redirectUrl: string}>('requestmeetingform/SubmitRequest', request);
    }
}

export default new RequestMeetingFormService();
